import API from '@/services/request/page';
import types from './types';

const api = new API();
const actions = {};
let params = {};

const request = (commit, pageIdentifier) =>
  api.locations(pageIdentifier, { catchError: true, params })
    .then((response) => {
      commit(types.LOCATIONS_SET_LIST, response.data);
    });

actions.getCoordinates = ({ commit, state }) =>
  api.locationCoordinates(state.pageIdentifier, { catchError: true })
    .then((response) => {
      commit(types.LOCATIONS_SET_COORDINATES, response.data);
    });

actions.requestLocations = ({ commit, state }) => {
  params.paginationPage = state.page;
  return request(commit, state.pageIdentifier);
};

actions.getLocations = ({ dispatch, commit }, pageIdentifier) => {
  commit(types.LOCATIONS_SET_PAGEIDENTIFER, pageIdentifier);
  dispatch('requestLocations', types.LOCATIONS_SET_LIST);
};

actions.getLocationsOfPage = ({ dispatch, commit }, page) => {
  commit(types.LOCATIONS_SET_PAGE, page);
  dispatch('requestLocations', types.LOCATIONS_SET_LIST);
};

actions.searchLocations = ({ commit, state }, { target }) => {
  commit(types.LOCATIONS_SET_PAGE, 1);
  params = { paginationPage: 1 };
  if (target.value) {
    params.query = target.value;
  }

  return request(commit, state.pageIdentifier);
};

export default actions;



// WEBPACK FOOTER //
// ./src/screens/Locations/store/actions.js